import React__default from 'react';
import PropTypes from 'prop-types';
import { brands } from '../../tools/constants.js';

var propTypes = {
  /** Assign a unique ID */
  id: PropTypes.string.isRequired,
  /** Indicate what the user is being asked */
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  /** Description of drop down. Must be an ID of an element in the DOM. */
  ariaDescribedBy: PropTypes.string,
  /**
   * [Autocomplete attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)
   */
  autoComplete: PropTypes.string,
  /** Specify the brand */
  brand: PropTypes.oneOf(brands),
  /** Indicate whether to use with an error message or not */
  children: PropTypes.node,
  /** Specify if the dropdown is disabled */
  isDisabled: PropTypes.bool,
  /** Specify if the dropdown is invalid. This works with error message. */
  isInvalid: PropTypes.bool,
  /** Indicate if the dropdown is required */
  isRequired: PropTypes.bool,
  /** Specify the name to make an instance of the component recognizable */
  name: PropTypes.string,
  /** Select a theme */
  theme: PropTypes.oneOf(['', 'inverse']),
  /** Input the value */
  value: PropTypes.string
};
function DropDown(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
    autoComplete = _ref.autoComplete,
    brand = _ref.brand,
    children = _ref.children,
    id = _ref.id,
    isDisabled = _ref.isDisabled,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    options = _ref.options,
    theme = _ref.theme,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "drop-down",
    "data-brand": brand || null,
    "data-testid": "drop-down",
    "data-theme": theme || null
  }, /*#__PURE__*/React__default.createElement("select", {
    autoComplete: autoComplete || null,
    "aria-describedby": ariaDescribedBy,
    "aria-disabled": isDisabled ? 'true' : null,
    "aria-invalid": isInvalid,
    "aria-required": isRequired ? 'true' : null,
    "data-filled": value !== '',
    disabled: isDisabled,
    id: id,
    name: name || null,
    onChange: onChange,
    required: isRequired,
    value: value
  }, value === '' && /*#__PURE__*/React__default.createElement("option", {
    "data-testid": "blank-default-option",
    label: " "
  }), /*#__PURE__*/React__default.createElement("optgroup", {
    label: label
  }, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: option.label,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/React__default.createElement("label", {
    className: "placeholder",
    "data-testid": "placeholder",
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement("span", {
    className: "float-label",
    "data-testid": "float-label"
  }, label), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "arrow-icon",
    "data-testid": "arrow-icon"
  }), children);
}
DropDown.propTypes = propTypes;

export { DropDown as default };
//# sourceMappingURL=DropDown.js.map
